<template>
  <div class="legends">
    <div class="item">
      <span class="safety-margin" />
      Linia cięcia
    </div>
    <div class="item">
      <span class="cutting-line" />
      Bezpieczny zadruk
    </div>
  </div>
</template>

<script>
export default {
  
};
</script>

<style lang="less" scoped>
.legends {
  display: flex;
  width: 100%;
  font-size: 12px;
  position: absolute;
  left: 20px;
  bottom: 20px;
}

.item {
  display: flex; 
  align-items: center;

  span {
    display: block;
    width: 40px;
    margin-right: 10px;
    border-bottom: 2px dashed transparent;


    &.safety-margin {
      border-color: red;
    }

    &.cutting-line {
      border-color: #0789ed;
    }
  }

  + .item {
    margin-left: 30px;
  }
}
</style>
